module.exports = __webpack_public_path__ + "img/Misi2-2-1Ilustrasi Thinking-Feeling.45c7ebf5.png";